<template lang="pug">
#vFormRender
  vFRender_view(v-bind="$attrs", ref="VFR_View", v-on="$listeners" @setFormData="setFormData")
    template(v-for="slot in Object.keys($scopedSlots)", v-slot:[slot]="scope")
      slot(:name="slot", v-bind="scope")
    template(v-for="(item, index) in slotList", :slot="item.name")
      component(v-bind="$attrs", v-on="$listeners", :is="item.compontent", ref="slotName", :key="index")
  .footer(v-if="hasSubmit")
    el-button(size="small", @click="handleCancel") 取 消
    el-button(type="primary", size="small", @click="submitForm") 确 定
</template>

<script>
/** *
 * 插槽和vform预览器分发数据
 * **/
import vFRender_view from "./vFRender_view.vue";
import { slotArrayList } from "./vFRsoltCom";
export default {
  name: "VFormRender",
  components: { vFRender_view },
  inheritAttrs: false,
  props: {
    // 表单显示提交按钮
    hasSubmit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 自定义插槽使用
    slotList() {
      return slotArrayList() || [];
    },
    $VFR_View() {
      return this.$refs.VFR_View;
    },
    formData() {
      return this.$VFR_View.formData;
    }
  },
  methods: {
    // 表单校验
    async startValidate() {
      return this.$VFR_View.startValidate();
    },
    // 获取表单数据
    async getFormData(needValidation = true) {
      let soltAllObj = {};
      if (this.$refs.slotName) {
        for (const iterator of this.$refs.slotName) {
          const soltObj = iterator?.getFormData?.(needValidation) || {};
          soltAllObj = { ...soltObj, ...soltAllObj };
        }
      }
      const obj = await this.$VFR_View.getFormData(needValidation);
      return Object.assign(soltAllObj, obj);
    },
    // 禁止表单编辑
    disableForm() {
      this.commonFunction("disableForm");
    },
    // 设置表单权限
    setFormPremission(list) {
      this.$VFR_View.setFormPremission(list);
    },
    getPrjId() {
      return this.$VFR_View.prjField;
    },
    // 设置表单数据
    setFormData(formData) {
      this.commonFunction("setFormData", formData);
    },
    async submitForm(url) {
      const res = await this.getFormData();
      return this.$VFR_View.submitForm(res, url);
    },
    handleCancel() {
      return this.$VFR_View.handleCancel();
    },
    updateFlowList() {
      return this.$VFR_View.updateFlowList();
    },
    getFieldWidgets() {
      return this.$VFR_View.getFieldWidgets();
    },
    disposalSubformPrefix(formData, isAdd) {
      this.$VFR_View.disposalSubformPrefix(formData, isAdd);
    },
    // 可以同时给给插槽赋值
    async commonFunction(methods, data) {
      this.$VFR_View?.[methods]?.(data);
      await this.$nextTick();
      if (this.$refs.slotName) {
        for (const iterator of this.$refs.slotName) {
          iterator?.[methods]?.(data);
        }
      }
    },
    resetExtraData(data = {}) {
      this.$VFR_View.extraData = data;
    },
    addExtraData(data = {}) {
      for (const [key, value] of Object.entries(data)) {
        if (this.$VFR_View.extraData[key]) {
          console.warn(`当前表单extraData的${key}属性已经有值，值为：${this.$VFR_View.extraData[key]}`);
        }
        this.$VFR_View.extraData[key] = value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#vFormReder {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
